import { useGetEntities } from '@abaninja/util-store';

import { getDeepBoxes } from '../connections/deepboxes';

export const useDeepBoxesStore = () => useGetEntities(getDeepBoxes);
